import React from "react";

const StatementTab = () => {
  return <div>StatementTab</div>;
};

export default StatementTab;
